import React from 'react';
import _ from 'underscore';
import { AddressValidation, FormValidation, GSTINValidation, TaxValidation, TaxCertValidation } from './components';
import { requiredFeatures } from '../required-features';

export const Rules = {
  Address: 'Address',
  Form: 'Form',
  GSTIN: 'GSTIN',
  Tax: 'Tax',
  TaxCert: 'TaxCert',
  Unknown: 'Unknown',
};

export const NoValidationRuleIndex = -1;

export const getDefaultValidationRules = ({ permissions }) => _.compact([
  { name: Rules.Form, component: <FormValidation /> },
  { name: Rules.Address, component: <AddressValidation /> },
  { name: Rules.GSTIN, component: <GSTINValidation /> },
  _.get(permissions, ['dynamic', requiredFeatures.ABLColombiaTax]) && { name: Rules.TaxCert, component: <TaxCertValidation /> },
  { name: Rules.Tax, component: <TaxValidation /> },
]);
